import {
  CustomTable,
  FilterGroupComponent,
  OverflowText,
  Title,
} from "components";
import { useMemo, useState } from "react";
import { useGetTransactionList } from "../services/AnalyticsPageService";
import storage from "services/storage";
import { capitalize } from "lodash";
import { formatDate } from "utils/formatDate";
import DetailTransactionModal from "./DetailTransactionModal";
import { paramParsify } from "utils/queryParams";
import { useLocation } from "react-router-dom";

const TransactionListSection = () => {
  const companyIdLocalStorage = storage.getCompanyID();
  const location = useLocation();
  const queryParams = paramParsify(location?.search);

  const [detailTransactionModal, setDetailTransactionModal] = useState({
    open: false,
  });

  const { response } = useGetTransactionList({
    id: companyIdLocalStorage,
    limit: 10,
    affiliated: false,
    defaultPeriodStart: queryParams?.period_start,
    defaultPeriodEnd: queryParams?.period_end,
    enableAutoFetchParams: true,
  });
  const data = useMemo(() => response?.data?.transactions ?? [], [response]);

  const headCells = [
    {
      id: "date",
      label: "Date",
    },
    {
      id: "sid",
      label: "SID",
    },
    {
      id: "name",
      label: "Investor Name",
      sorter: true,
    },
    {
      id: "transaction_type",
      label: "Type",
      sorter: true,
    },
  ];
  const bodyCells = useMemo(
    () =>
      data?.map((el) => ({
        ...el,
        rawDate: el?.date,
        rawSid: el?.sid,
        rawName: el?.name,
        rawTransactionType: el?.transaction_type,
        date: <p className='text-sm'>{formatDate.toShortDate(el?.date)}</p>,
        sid: <p className='text-sm'>{el?.sid}</p>,
        name: <OverflowText text={el?.name} textClassName='text-sm' />,
        transaction_type:
          el?.transaction_type === "BUY" || el?.transaction_type === "SELL" ? (
            <div
              className={`rounded-full px-2 py-1 text-sm max-w-[42px] ${
                el?.transaction_type === "BUY"
                  ? "bg-[#E6F5EF] text-[#039E5A]"
                  : "bg-[#FCEAED] text-[#E52A49]"
              }`}
            >
              {capitalize(el?.transaction_type)}
            </div>
          ) : (
            capitalize(el?.transaction_type)
          ),
      })),
    [data],
  );

  const handledetailTransactionModal = (data) => {
    setDetailTransactionModal({
      open: true,
      data,
    });
  };

  const handleCloseDetailTransactionModal = () => {
    setDetailTransactionModal({ open: false });
  };

  return (
    <div className='section'>
      <Title
        className='mb-6'
        title='Transaction List'
        tooltipText='Our data provides a daily closing market comparison, not capturing intra-day transactional changes.'
      />
      <div className='mb-5'>
        <FilterGroupComponent
          showStatusFilter={false}
          showTypeFilter={false}
          showDateRangePicker={false}
          searchPlaceholder='Search by Exact Name and SID'
        />
      </div>
      <CustomTable
        id='transaction-list-table'
        headCells={headCells}
        bodyCells={bodyCells ?? []}
        bodyCellKey='id'
        total={response?.data?.total ?? 0}
        onRowClick={handledetailTransactionModal}
      />
      {detailTransactionModal?.open && (
        <DetailTransactionModal
          modalProps={{
            open: detailTransactionModal?.open,
            onClose: () => handleCloseDetailTransactionModal(),
          }}
          data={detailTransactionModal?.data}
          onClose={handleCloseDetailTransactionModal}
        />
      )}
    </div>
  );
};

export default TransactionListSection;
